import React from 'react';
import {makeStyles, Box, Grid} from '@material-ui/core';
import axios from 'axios';
import { MathJaxContext, MathJax } from "better-react-mathjax";
import html2canvas from 'html2canvas';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogStudyContent from './DialogStudyContent';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
// import VolumeUpIcon from '@mui/icons-material/VolumeUp';
// import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {API_URL, OPENAI_API_KEY} from '../utils/EnvVars';
import '../styles/bizofficer-a.css';

const config = {
	/* in theory, the MathML input processor should be activated if we add
	an "mml" block to the config OR if "input/mml" (NOT "input/mathml" as stated 
	in the docs) is in the load array. However, this is not necessary as MathML is 
	ALWAYS enabled in MathJax */
	loader: { load: ["input/mml", "output/chtml"] },
	mml: {}
  };

  const useStyles = makeStyles({
    dialog: {
      position: 'absolute',
      left: 0,
      
    },
  });

  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }
  

function DialogHelp(props, ref) {  
  const classes = useStyles();
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 	
	
  var mySelectedCourses = {};
  if(localStorage.getItem('etlMyCourses')){
    mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  }

  var etlStudentObj = {};
  if(localStorage.getItem('etlStudentObj')){
    etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
  }

  const [ttsBtnOpt, setTtsBtnOpt] = React.useState(1);
  const openHelpContentRef = React.useRef();
  const [open, setOpen] = React.useState(false);
  const [showProgress, setShowProgress] = React.useState(false);
	const [materialsDisplayList, setMaterialsDisplayList] = React.useState([]);
	const [contentObj, setContentObj] = React.useState("");
  const [helpOption, setHelpOption] = React.useState(1);
  const [aisolution, setAisolution] = React.useState("");
  const [callOpenAIFlag, setCallOpenAIFlag] = React.useState(false);
  const [callSaveAnsFlag, setCallSaveAnsFlag] = React.useState(false);
  const [promptTxt, setPromptTxt] = React.useState("");
  ///const [aiName, setAiName] = React.useState("");
  const [aiModel, setAiModel] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    //cancelSpeakNow();
    props.toCallStartTimer();
    setOpen(false);    
  };

  // function googleSearch(){
	// 	setContentObj(null);
  //   openHelpContentRef.current.handleClickOpen();		
	// }

  function exeContent(obj){ 
		if(obj && obj.contentType===1){
			setContentObj(obj);
			openHelpContentRef.current.handleClickOpen();	
		}else{
			if(window.screen.width<480){
				window.open(obj.contentUrl, "_blank");
			}else{
				setContentObj(obj);
				openHelpContentRef.current.handleClickOpen();
			}
		}	
	}

  const descriptionElementRef = React.useRef(null);  
  React.useEffect(() => {
    if (open) { 
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
      setHelpOption(4);
      setShowProgress(true);      
      callApiToGetAnswer();
    }
  }, [open]);

  React.useEffect(() => {
    setTtsBtnOpt(1);
    setAisolution("");
    setCallOpenAIFlag(false);
    setCallSaveAnsFlag(false); 
    ///setShowProgress(false);
    if(open){    
          //call API for prompt......
          if(props.currentQuestionObj && props.currentQuestionObj.topicId>0){
            getApiDataOpenAIPrompt(props.currentQuestionObj);
          }
      if(mySelectedCourses && selectedCourse>=0 && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].tonyHelp>0){
        setHelpOption(4);
      }else{
        setHelpOption(1);
      }  
      if(mySelectedCourses!==null && selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId && props.currentQuestionObj){
        getApiDataSmartLearning(mySelectedCourses[selectedCourse].templateId,'Topic',props.searchQuery,props.currentQuestionObj.topicId); 
      }else if(mySelectedCourses!==null && selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId && props.currentQuestionObj){
        getApiDataSmartLearning(mySelectedCourses[selectedCourse].templateId,'Topic','testview',props.currentQuestionObj.topicId); 
      }
    }
	}, [open,selectedCourse,props.searchQuery,props.currentQuestionObj]); 

	async function getApiDataSmartLearning(templateId,searchFlag,searchQuery,topicId){
      let axiosHeader = {
        headers:{
          'Content-Type': 'multipart/mixed',
          'loginId': etlStudentObj?.loginId,
          'token': etlStudentObj?.token,
          'device': 'web'
        }
      }; 
			axios.get(API_URL+'/helpcontent?templateId='+templateId+'&searchFlag='+searchFlag+'&searchQuery='+searchQuery+'&topicId='+topicId, axiosHeader)
			   .then(response => { 
        if(response && response.status === 200 && response.data.responseTxt === "success"){ 
				 	
          setMaterialsDisplayList(response.data.obj);	 

        }		 				
			})
	}

  React.useEffect(() => {
    if(open && helpOption===4 && callSaveAnsFlag){
      // alert("callApiToSaveAnswer: "+helpOption+"==="+callSaveAnsFlag);
      callApiToSaveAnswer();      
    }else if(open && helpOption===4 && callOpenAIFlag){
      // alert("callOpenAIToGetAnswer: "+helpOption+"==="+callOpenAIFlag);
      callOpenAIToGetAnswer();
    } 
  }, [open,helpOption,callSaveAnsFlag,callOpenAIFlag]); 

  
  // async function callOpenAIToGetAnswer(){
	// 	let div = document.getElementById('questionBox' + props.currentQuestion);	
	// 	html2canvas(div).then(
	// 		function (canvas) {
	// 			///alert(canvas);
	// 			///document.writeln(canvas);
	// 			document.getElementById("screenshot").appendChild(canvas);
	// 		}
	// 	)
  // }

  
  async function callOpenAIToGetAnswer(){    

    let qbContent = "";
    if(props.currentQuestionObj.commonDataDescription && props.currentQuestionObj.commonDataDescription.length > 0){
      qbContent += props.currentQuestionObj.commonDataDescription+"\n";
    }

    qbContent += props.currentQuestionObj.questionBody;

    let i=0, j=0;            	
    if(props.currentQuestionObj.columns!=null && props.currentQuestionObj.columns.length>0) {            		
      for(i=0; i<props.currentQuestionObj.columns.length; i++) {
      		qbContent += "\n"+props.currentQuestionObj.columns[i].columnHeader+"\n";            			
          if(props.currentQuestionObj.columns[i].columnRows!=null && props.currentQuestionObj.columns[i].columnRows.length>0 ) {
          	for(j=0; j<props.currentQuestionObj.columns[i].columnRows.length; j++) {            					
          		qbContent += props.currentQuestionObj.columns[i].columnRows[j].rowId+" "+props.currentQuestionObj.columns[i].columnRows[j].rowName+"\n";
          	}
          }
      }
    }
    
    if(props.currentQuestionObj.responseChoice && props.currentQuestionObj.responseChoice.length>0){
      for(let i=0; i<props.currentQuestionObj.responseChoice.length; i++){
        qbContent += "\n"+props.currentQuestionObj.responseChoice[i].responseId+". "+props.currentQuestionObj.responseChoice[i].responseText;
      }
    }

    if(qbContent.indexOf("svg")>-1){
      let div = document.getElementById('questionBox' + props.currentQuestion);
   		html2canvas(div).then(
        function (canvas) {
          qbContent = canvas.toDataURL();
        }
      )
    }

    let axiosHeader = {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Authorization': `Bearer ${OPENAI_API_KEY}`,
      }
    };    
    // gpt-3.5-turbo gpt-4-1106-preview gpt-4-vision-preview
    const data = JSON.stringify({
      "model": aiModel, //o3-mini     
      "reasoning_effort": "medium", // Ensures deep logical reasoning
      "tools": [
        {
          "type": "function",
          "function": { "name": "web_search" }, // ✅ Correctly specifying the function
        },
      ], // Enables live search for citations
      "tool_choice": "auto",
      "messages": [
        {
          "role": "system",
          "content": promptTxt,
// =======
//       model: "o3-mini",
//       reasoning_effort: "medium", // Ensures deep logical reasoning
//       tools: [
//         {
//           type: "function",
//           function: { name: "web_search" }, // ✅ Correctly specifying the function
// >>>>>>> main
//         },
//       ], // Enables live search for citations
//       tool_choice: "auto", // Lets the model decide when to search
//       messages: [
//         {
//           role: "system",
//           content:
//             "First explain the concept in detail. In second step, analyse all the options explaining why they are correct or incorrect and finally arrive at correct answer. Thereater, give citations first from books, then from articles and lastly research papers without links. Send a structured html body as response to be rendered on page with no styling properties.",
        },
        { "role": "user", "content": qbContent.trim() },
      ],
    });
    axios.post('https://api.openai.com/v1/chat/completions', data, axiosHeader)
       .then(response => {
      if(response.data && response.data.choices && response.data.choices[0].message.content){
          setAisolution(response.data.choices[0].message.content);          
          setShowProgress(false);
          setCallOpenAIFlag(false);
          setCallSaveAnsFlag(true);
      } 				
    }).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})
  }

  async function callApiToSaveAnswer(){    
    let axiosHeader = {
      headers:{
        'Content-Type': 'multipart/mixed',
        // 'loginId': etlStudentObj.loginId,
        // 'token': etlStudentObj.token,
        // 'device': 'web'
      }
    };   

    if(props.currentQuestionObj && (props.currentQuestionObj.questionId>0 || props.currentQuestionObj.itemId>0) ){  
      const data = new FormData();
      if(props.currentQuestionObj.questionDisplayId){
        data.append("questionDisplayId", props.currentQuestionObj.questionDisplayId);
      }else{
        data.append("questionDisplayId", '');
      }
      if(props.currentQuestionObj.questionId && props.currentQuestionObj.questionId>0){
        data.append("questionId", props.currentQuestionObj.questionId);
      }else{
        data.append("questionId", 0);
      }
      if(props.currentQuestionObj.itemId && props.currentQuestionObj.itemId>0){
        data.append("itemId", props.currentQuestionObj.itemId);
      }else{
        data.append("itemId", 0);
      }
      data.append("solution", aisolution);
      data.append("topicId", props.currentQuestionObj.topicId);
      ///data.append("questionSet", JSON.stringify(props.currentQuestionObj));       
      axios.post(API_URL +'/app/openai-addnew', data, axiosHeader)
        .then(response => {
          if(response && response.status === 200 && response.data.responseTxt === "success"){
            console.info("Saved Answer");
            setCallSaveAnsFlag(false);
          }	 				
      })
    }
  }

  async function callApiToGetSavedAnswer(){
    setHelpOption(4);  
    if(!aisolution){
      let axiosHeader = {
        headers:{
          'Content-Type': 'multipart/mixed',
          // 'loginId': etlStudentObj.loginId,
          // 'token': etlStudentObj.token,
          // 'device': 'web'
        }
      };     
      setShowProgress(true);

      let itemId = 0;
      if(props.currentQuestionObj.itemId && props.currentQuestionObj.itemId>0){
        itemId = props.currentQuestionObj.itemId;
      }
      axios.get(API_URL +'/app/openai-list?questionId='+props.currentQuestionObj.questionId+'&itemId='+itemId, axiosHeader)
        .then(response => { 
          ///document.writeln(JSON.stringify(response));        
        if(response && response.status===200 && response.data.responseTxt === "success"){
          setAisolution(response.data.obj.solution);
          setShowProgress(false);
        }else{          
          setCallOpenAIFlag(true);
        }	 				
      })
    }
  }

	async function getApiDataOpenAIPrompt(qObj){
    let axiosHeader = {
      headers:{
        'Content-Type': 'multipart/mixed',
        // 'loginId': etlStudentObj.loginId,
        // 'token': etlStudentObj.token,
        // 'device': 'web'
      }
    };   
    axios.get(API_URL+'/app/student/openai-rules?topicId='+qObj.topicId+'&questionType='+qObj.questionType, axiosHeader)
       .then(response => { 
      if(response && response.status === 200 && response.data.responseTxt === "success"){ 
        if(response.data.obj && response.data.obj.promptTxt.length>0){
          //setAiName(response.data.obj.aiName);	
          setAiModel(response.data.obj.aiModel);	 
          setPromptTxt(response.data.obj.promptTxt);	 
        }
      }else{
        setPromptTxt('First explain the concept in detail. In second step, analyse all the options explaining why they are correct or incorrect and finally arrive at correct answer. Thereafter, give citations first from books, then from articles and lastly research papers without links. Send a structured html body as response to be rendered on page with no styling properties.');
        ///setAiName(response.data.obj.aiName);	
        setAiModel("o3-mini");
      }		 				
    })
  }



  function goGoogle() {
    const alphaArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    let options = "";
    if(props.currentQuestionObj.responseChoice && props.currentQuestionObj.responseChoice.length>0){
      for(let i=0; i<props.currentQuestionObj.responseChoice.length; i++){
        options += " "+alphaArr[i]+". "+props.currentQuestionObj.responseChoice[i].responseText;
      }
    }
    window.open("https://www.google.com/search?igu=1&q="+encodeURIComponent(document.getElementById('questionBodyDivI').innerText.replace(/ +(?= )/g,'')+options));
    
  }

		

  async function callApiToGetAnswer(){
    setHelpOption(4);  
    //if(!aisolution){
      let axiosHeader = {
        headers:{
          'Content-Type': 'multipart/mixed',
          // 'loginId': etlStudentObj.loginId,
          // 'token': etlStudentObj.token,
          // 'device': 'web'
        }
      };     
      setShowProgress(true);

      let itemId = 0;
      if(props.currentQuestionObj.itemId && props.currentQuestionObj.itemId>0){
        itemId = props.currentQuestionObj.itemId;
      }
      axios.get(API_URL +'/app/studentpanel/openai?questionId='+props.currentQuestionObj.questionId+'&itemId='+itemId, axiosHeader)
        .then(response => { 
        setShowProgress(false);  
          ///document.writeln(JSON.stringify(response));        
        if(response && response.status===200 && response.data.responseTxt === "success"){
          setAisolution(response.data.obj.solution);          
        }else{
          setAisolution("It could not find solution for some reason. Try after sometime");
        }	 				
      })
    //}
  }



 
  return (
    <>      
      <Dialog 
        classes={{
          paper: classes.dialog
        }}
        open={open}
        onClose={handleClose}
        scroll={'paper'}
        key={'help123'}
        aria-labelledby="draggable-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth 
        maxWidth="md"
        PaperComponent={PaperComponent}        
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title" >
          {props.searchQuery} 
          {(showProgress && helpOption!==4)?<><CircularProgress style={{width:20,height:20}} />Loading...</>:null}
        {/* <div>{helpOption===3?<><a href='#' onClick={()=>{googleIframeHistoryBack()}} >Back</a> <a href="#" onClick={()=>{}} >Next</a> </>:null}</div> */}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          title='Close'
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers={'paper'}          
        >
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1} 
            // PaperProps={{ sx: { overflowY: 'scroll',  overflowX: 'hidden', width: 1200 } }}
          >
                <Box component="form" noValidate style={{marginTop:-15}}>
                  <div className="materialBox" >
                  {helpOption===4? 
                    <small>Kindly prefer to search the answer first from your Books. Then ask TONY. Try to know the reasons of the answer and not only the answer. DO NOT GUESS.</small>
                  :helpOption!==3?
                    <small>Kindly prefer to search the answer first from your Books. Try to know the reasons of the answer and not only the answer. DO NOT GUESS.</small>
                  :null}
                  </div>
                </Box>

								<Box component="form" noValidate mt={1} >
									<Grid container spacing={2} className="materialBox" style={helpOption===4?{height: 250}:helpOption===1?{height: 150, width: 'max-content'  }:{}} >
                    {/* <div>{"showProgress: "+showProgress}</div> */}
                    {/* {"\nfoundSolution: "+foundSolution}
                    {"\naisolution: "+aisolution} */}
                    {helpOption===4?<>                        
                        <Box><img src={process.env.PUBLIC_URL + "/tony.png"} style={{height:75, borderRadius: '50%'}} alt="TONY-AI" /></Box>
                        {showProgress?<div style={{display: 'flex', alignItems: 'center', float:'none', marginTop:110, marginLeft:-80, fontSize: 12}} ><CircularProgress style={{width:20,height:20}} /><span style={{marginLeft: '20px'}}></span>Please wait I am working to help you</div>
                        :(!showProgress && aisolution && aisolution.length>0)?<>                          
                          
                          {/* {window.screen.width>480?
                            <div style={{marginTop:25,marginLeft:10}}>
                            {ttsBtnOpt===3?  
                              <Button endIcon={<VolumeUpIcon />} variant={'outlined'} style={{textDecoration:'none'}} size='small' title='Speak' onClick={()=>{resumeNow()}} >Speak</Button>
                            :ttsBtnOpt===2? 
                              <Button endIcon={<PauseCircleIcon />} variant={'outlined'} style={{textDecoration:'none'}} size='small' title='Pause' onClick={()=>{pauseNow()}} >Pause</Button>
                            : // Start
                              <Button endIcon={<VolumeUpIcon />} variant={'outlined'} style={{textDecoration:'none'}} size='small' title='Speak' onClick={()=>{speakNow()}} >Speak</Button>
                            }  
                            </div>      
                          :null} */}

                          <div id="aiSolutionDivId" style={{marginTop:5,float:'none',verticalAlign:'top'}}>
                            <MathJaxContext version={3} config={config}><MathJax><div className="aiSolution_body" dangerouslySetInnerHTML={{ __html: aisolution}} /></MathJax></MathJaxContext>
                          </div>                          
                          <div style={{fontSize:12, marginTop:20}}>
                              Disclaimer: Tony AI is an NLP model for increasing conceptual understanding and sometimes may give inaccurate answers more so in image-based questions. When in doubt, seek ETL teachers support in Report & Analytics. ETL Teacher would also respond if you have SKIPPED the question. 
                          </div>
                          </>
                        :<>
                        <div style={{marginTop:90, marginLeft:-75, fontSize: 12}} >
                          {(mySelectedCourses && selectedCourse>=0 && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].tonyHelp>0)?<>
                              {(promptTxt && promptTxt.length>0)?<Button variant={'outlined'} style={{textDecoration:'none'}} size='small' onClick={helpOption===4?()=>{callApiToGetAnswer()}:()=>{}} title='Ask Tony (Your AI Teacher)' >Ask Tony (Your AI Teacher)</Button>:null}
                          </>:<span style={{fontWeight:'bold',color:'red',fontSize:15}} >Your current package does not include Tony AI feature</span>}  
                        </div>
                        </>}
                     </>
                    :(helpOption===2 && props.currentQuestionObj.explanations && props.currentQuestionObj.explanations.length>0)?
                        <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: props.currentQuestionObj.explanations.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
                    :(helpOption===1 && materialsDisplayList.length)?materialsDisplayList.map((myRow,index)=>(				
                      <Grid onClick={()=>{exeContent(myRow)}} key={'mtldd'+index} item className="smitem" >
                        <p>
                          {myRow.contentType==1?<i className="fa fa-play-circle"></i>:myRow.contentType==2?<i className="fa fa-file-pdf-o"></i>:myRow.contentType==3?<i className="fa fa-file-powerpoint-o"></i>:<i className="fa fa-globe"></i>}												
                        </p>
                        <p className="text-line-2">
                          {myRow.contentTitle}
                        </p>	
                      </Grid>
                    )):(helpOption!==3 && showProgress)?<><CircularProgress style={{width:20,height:20}} />Loading...</>:<b style={{color:'blue'}}>Kindly search from Google</b>}	
                </Grid>	
							</Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        {/* {(mySelectedCourses && selectedCourse>=0 && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].tonyHelp>0)?
          <Button className='helpbtn' variant={helpOption===4?'contained':'text'} size='small' style={{height:25}} onClick={helpOption!==4?()=>{setHelpOption(4)}:()=>{}}>Tony-AI</Button>
        :null} */}
        {/* <Button className='helpbtn' variant={helpOption===3?'contained':'text'} size='small' style={{height:25}} onClick={()=>{goGoogle()}}><i class="fa fa-google" aria-hidden="true">oogle</i></Button> */}
        {/* {(props.currentQuestionObj && props.currentQuestionObj.explanations && props.currentQuestionObj.explanations.length>0)?
            <Button className='helpbtn' variant={helpOption===2?'contained':'text'} size='small' style={{height:25}} onClick={helpOption!==2?()=>{setHelpOption(2)}:()=>{}} >ETL-Help</Button>
        :null} */}
        {/* {(materialsDisplayList!=null && materialsDisplayList.length>0)?
            <Button className='helpbtn' variant={helpOption===1?'contained':'text'} size='small' style={{height:25}} onClick={helpOption!==1?()=>{setHelpOption(1)}:()=>{}}>Study Material</Button>
        :null} */}
        <Button className='helpbtn desktop-section' variant={'text'} size='small' onClick={handleClose} title='Close' >Close</Button>
        </DialogActions>
      </Dialog>
      <DialogStudyContent contentObj={contentObj} ref={openHelpContentRef} />
      <div id="questionBodyDivI" hidden >
        {(props.currentQuestionObj && props.currentQuestionObj.questionBody)?
            <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: props.currentQuestionObj.questionBody.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
        :null}  
      </div>
    </>
  );
}

export default React.forwardRef(DialogHelp);